import { DEFAULT_DASHBOARD } from '@/plugins/dashboard'
import { SET_CONFIGURATION_DASHBOARD } from '@/store/mutation-types'

const state = {}

const getters = {
  workspace: (state) => (dashboard) => state[dashboard] || DEFAULT_DASHBOARD
}

const mutations = {
  [SET_CONFIGURATION_DASHBOARD] (state, dashboard) {
    Object.assign(state, dashboard)
  }
}

const actions = {
  saveDashboard ({ commit }, dashboard) {
    commit(SET_CONFIGURATION_DASHBOARD, dashboard)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
